import { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import "../App.css";

const CREAR_PRODUCTO = gql`
mutation crearProductoProveedor($nombre: String, $imagen: String, $precio: Decimal, $codigo: String, $stock: Int, $proveedores: [String]) {
  crearProductoProveedor(nombre: $nombre, imagen: $imagen, precio: $precio, codigo: $codigo, stock: $stock, proveedores: $proveedores) {
    _id
    nombre
    precio
    stock
    codigo
    imagen
    proveedores
  }
}`;

const GET_PRODUCTO = gql`
query getProductos {
  getProductos {
    _id
    nombre
    imagen
    precio
    codigo
    stock
    proveedores
  }
}`;

const ELIMINAR_PRODUCTO = gql`
mutation eliminarProductoProveedor($id: ID!) {
  eliminarProductoProveedor(_id: $id)
}`;

const ACTUALIZAR_PRODUCTO = gql`
mutation editarProductoProveedor($id: ID!, $nuevoNombre: String, $nuevaImagen: String, $nuevoCodigo: String, $nuevoStock: Int, $nuevoPrecio: Decimal, $nuevoProveedores: [String]) {
  editarProductoProveedor(_id: $id, nombre: $nuevoNombre, imagen: $nuevaImagen, codigo: $nuevoCodigo, stock: $nuevoStock, precio: $nuevoPrecio, proveedores: $nuevoProveedores) {
    _id
    nombre
    precio
    stock
    codigo
    imagen
    proveedores
  }
}`;

function ProductosJson() {
  const { loading, error, data } = useQuery(GET_PRODUCTO);

  const [crearProducto] = useMutation(CREAR_PRODUCTO, {
    refetchQueries: [{ query: GET_PRODUCTO }],
  });

  const [eliminarProducto] = useMutation(ELIMINAR_PRODUCTO, {
    refetchQueries: [{ query: GET_PRODUCTO }],
  });

  const [editarProducto] = useMutation(ACTUALIZAR_PRODUCTO);

  // Estados formulario crear
  const [nombre, setNombre] = useState("");
  const [precio, setPrecio] = useState(0);
  const [stock, setStock] = useState(0);
  const [codigo, setCodigo] = useState("");
  const [imagen, setImagen] = useState("");
  const [proveedoresInput, setProveedoresInput] = useState("");

  // Estados edición
  const [editingProduct, setEditingProduct] = useState(null);
  const [nuevoNombre, setNuevoNombre] = useState("");
  const [nuevaImagen, setNuevaImagen] = useState("");
  const [nuevoCodigo, setNuevoCodigo] = useState("");
  const [nuevoStock, setNuevoStock] = useState(0);
  const [nuevoPrecio, setNuevoPrecio] = useState(0);
  const [proveedoresInputEdit, setProveedoresInputEdit] = useState("");

  const parseProveedores = (value) => {
    if (!value) return [];
    return value.split(",").map(v => v.trim()).filter(Boolean);
  };

  const productoSubmit = (e) => {
    e.preventDefault();

    crearProducto({
      variables: {
        nombre,
        precio: parseFloat(precio),
        stock: parseInt(stock),
        codigo,
        imagen,
        proveedores: parseProveedores(proveedoresInput),
      },
    });
  };

  const descargarJSON = () => {
    const dataStr = JSON.stringify(data.getProductos, null, 2);
    const blob = new Blob([dataStr], { type: "application/json" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "productos.json";
    link.click();

    URL.revokeObjectURL(url);
  };

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  const sortData = [...data.getProductos].sort((a, b) =>
    a.nombre.localeCompare(b.nombre)
  );

  return (
    <div>

      {/* 📥 JSON VIEW + DOWNLOAD */}
      <div className="card">
        <div className="card-body">
          <h2>Exportar productos</h2>

          <button className="btn btn-success" onClick={descargarJSON}>
            Descargar JSON
          </button>

          <pre style={{
            background: "#111",
            color: "#0f0",
            padding: "10px",
            marginTop: "10px",
            maxHeight: "300px",
            overflow: "auto"
          }}>
            {JSON.stringify(data.getProductos, null, 2)}
          </pre>
        </div>
      </div>

    

    
      <div className="container">
        <h3>Total productos: {data.getProductos.length}</h3>

        <div className="row">
         
        </div>
      </div>

    </div>
  );
}

export default ProductosJson;